import CustomInput from "../../../shared/CustomInput";
import { Plus, X } from "lucide-react";
import Loading from "../../../shared/Loading";
import { uploadImage } from "../../../sdk/upload/upload";
import { useRef } from "react";

const EditGuarantor = ({
  closeEditGuarantor,
  loading,
  guarantorEditDetails,
  setGuarantorEditDetails,
  handleEditGuarantor,
}) => {
  const fileInputRef1 = useRef(null);
  const fileInputRef2 = useRef(null);

  const handleChange = (field, value) => {
    setGuarantorEditDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleChooseFileClick1 = () => fileInputRef1.current?.click();
  const handleChooseFileClick2 = () => fileInputRef2.current?.click();

  const handleFileChange1 = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const response = await uploadImage(file);
      if (response?.url) {
        setGuarantorEditDetails((prev) => ({
          ...prev,
          guarantorPhoto: response.url,
        }));
      }
    }
  };

  const handleFileChange2 = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const response = await uploadImage(file);

      if (response?.url) {
        setGuarantorEditDetails((prev) => ({
          ...prev,
          guarantorBusinessPhoto: response.url,
        }));
      }
    }
  };
  return (
    <div
      onClick={() => closeEditGuarantor()}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[900px] h-[650px] rounded-[10px] p-[20px] relative bg-white overflow-y-auto"
      >
        <div
          onClick={closeEditGuarantor}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px]">
          Edit Guarantor Details
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-[20px]">
          Please update the guarantor details below to ensure accuracy of your
          loan application.
        </p>
        {/* Form */}
        <div className="flex flex-col gap-[10px]">
          <div className="flex items-start justify-between">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Guarantor Name
              </label>
              <CustomInput
                placeholder="Enter guarantor name"
                type="text"
                value={guarantorEditDetails?.guarantorName || ""}
                onChange={(e) => handleChange("guarantorName", e.target.value)}
              />
            </div>
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Location
              </label>
              <CustomInput
                placeholder="Enter guarantor location"
                type="text"
                value={guarantorEditDetails?.residenceLocation || ""}
                onChange={(e) =>
                  handleChange("residenceLocation", e.target.value)
                }
              />
            </div>
          </div>

          <div className="flex items-start justify-between">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Guarantor Phone Number
              </label>
              <CustomInput
                placeholder="Enter guarantor mobile number"
                type="text"
                value={guarantorEditDetails?.guarantorPhone || ""}
                onChange={(e) => handleChange("guarantorPhone", e.target.value)}
              />
            </div>
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Guarantor Email
              </label>
              <CustomInput
                placeholder="Enter guarantor email"
                type="text"
                value={guarantorEditDetails?.guarantorEmail || ""}
                onChange={(e) => handleChange("guarantorEmail", e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-start justify-between">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Guarantee Amount
              </label>
              <CustomInput
                placeholder="Enter guarantee amount"
                type="text"
                value={guarantorEditDetails?.guaranteeAmount || ""}
                onChange={(e) =>
                  handleChange("guaranteeAmount", e.target.value)
                }
              />
            </div>
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Reason
              </label>
              <CustomInput
                placeholder="Enter guarantee reason"
                type="text"
                value={guarantorEditDetails?.reason || ""}
                onChange={(e) => handleChange("reason", e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-start justify-between">
            <div className="w-[49%] flex flex-col">
              <label className="text-[#222222] font-medium text-[13px]">
                Location link
              </label>
              <CustomInput
                placeholder="Enter guarantor location link"
                type="text"
                value={guarantorEditDetails?.locationLink || ""}
                onChange={(e) => handleChange("locationLink", e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="flex my-[20px] items-start justify-between">
          <div className="w-[47%]">
            <p className="text-[15px] font-[#333333] font-medium">
              Guarantor photo
            </p>
            <div
              onClick={handleChooseFileClick1}
              className="h-[130px] flex items-center gap-[10px] cursor-pointer"
            >
              {guarantorEditDetails?.guarantorPhoto && (
                <div className="h-full w-[180px] rounded-[15px] relative overflow-hidden">
                  <>
                    {/* Image */}
                    <img
                      className="h-full w-full rounded-[15px] object-cover"
                      src={guarantorEditDetails?.guarantorPhoto}
                      alt="businessImageUrl"
                    />

                    {/* View icon - top right */}
                    <button
                      className="absolute top-2 right-2 bg-opacity-70 p-1"
                      onClick={() => console.log("View image")}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1554_3633)">
                          <rect width="24" height="24" rx="5" fill="white" />
                          <path
                            d="M6.64084 17.3586L9.55058 17.372L9.54139 18.3627L5.63604 18.3634L5.63675 14.458L6.64084 14.4623V17.3586ZM6.64084 6.64024L6.64084 9.53655L5.63533 9.5408L5.63604 5.63545L9.54139 5.63615L9.55058 6.62681L6.64084 6.64024ZM17.3726 17.372L17.386 14.4623L18.364 14.4587V18.3634L14.4579 18.3634L14.4763 17.372H17.3726ZM17.3726 6.62681L14.4763 6.62681L14.4586 5.63615L18.364 5.63545V9.5415L17.386 9.53655L17.3726 6.62681Z"
                            fill="#5C5C5C"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1554_3633">
                            <rect width="24" height="24" rx="5" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </>
                </div>
              )}
              <input
                type="file"
                ref={fileInputRef1}
                className="hidden"
                onChange={handleFileChange1}
              />
              <div className="h-full bg-[#F3F3F3] cursor-pointer w-[180px] rounded-[15px] flex flex-col items-center justify-center">
                <Plus size={24} color="#000" />
                <p className="text-center text-[10px] text-[#000]">
                  Replace photo Drag and Drop files here or{" "}
                  <span className="text-[#000000] underline">
                    Choose file here
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="w-[47%]">
            <p className="text-[15px] font-[#333333] font-medium">
              Guarantor business photo
            </p>
            <div
              onClick={handleChooseFileClick2}
              className="h-[130px] flex items-center gap-[10px] cursor-pointer"
            >
              {guarantorEditDetails?.guarantorBusinessPhoto && (
                <div className="h-full w-[180px] rounded-[15px] relative overflow-hidden">
                  <>
                    {/* Image */}
                    <img
                      className="h-full w-full rounded-[15px] object-cover"
                      src={guarantorEditDetails?.guarantorBusinessPhoto}
                      alt="businessImageUrl"
                    />

                    {/* View icon - top right */}
                    <button
                      className="absolute top-2 right-2 bg-opacity-70 p-1"
                      onClick={() => console.log("View image")}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_1554_3633)">
                          <rect width="24" height="24" rx="5" fill="white" />
                          <path
                            d="M6.64084 17.3586L9.55058 17.372L9.54139 18.3627L5.63604 18.3634L5.63675 14.458L6.64084 14.4623V17.3586ZM6.64084 6.64024L6.64084 9.53655L5.63533 9.5408L5.63604 5.63545L9.54139 5.63615L9.55058 6.62681L6.64084 6.64024ZM17.3726 17.372L17.386 14.4623L18.364 14.4587V18.3634L14.4579 18.3634L14.4763 17.372H17.3726ZM17.3726 6.62681L14.4763 6.62681L14.4586 5.63615L18.364 5.63545V9.5415L17.386 9.53655L17.3726 6.62681Z"
                            fill="#5C5C5C"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_1554_3633">
                            <rect width="24" height="24" rx="5" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </>
                </div>
              )}
              <input
                type="file"
                ref={fileInputRef2}
                className="hidden"
                onChange={handleFileChange2}
              />
              <div className="h-full bg-[#F3F3F3] cursor-pointer w-[180px] rounded-[15px] flex flex-col items-center justify-center">
                <Plus size={24} color="#000" />
                <p className="text-center text-[10px] text-[#000]">
                  Replace photo Drag and Drop files here or{" "}
                  <span className="text-[#000000] underline">
                    Choose file here
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditGuarantor}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleEditGuarantor}
            disabled={loading}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loading && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditGuarantor;
